// extracted by mini-css-extract-plugin
module.exports = {"navbar-menu":"styles-m__navbar-menu__hrIOX","menu-wrapper":"styles-m__menu-wrapper__2KpML","menu-item":"styles-m__menu-item__3Kfm3","logo":"styles-m__logo__3hhg5"};